// extracted by mini-css-extract-plugin
export default {"titleHolder":"Pictures_titleHolder__AAFAW","imgContainer":"Pictures_imgContainer__sThy+","container":"Pictures_container__qQVo5","imgBox":"Pictures_imgBox__x7a0n"};